import { render, staticRenderFns } from "./AddUpdateReview.vue?vue&type=template&id=0b512019"
import script from "./AddUpdateReview.vue?vue&type=script&lang=js"
export * from "./AddUpdateReview.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateReview.vue?vue&type=style&index=0&id=0b512019&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports